<template>
  <div>
    <Header />
<!--    <Aside />
    <Schedule />
    <Instructors />
    <Sponsor />
    <CommercialZone />
    <Download /> -->
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header/Header.vue'
/* import Aside from '@/components/Aside/Aside.vue'
import Instructors from '@/components/Instructors/Instructors.vue'
import Sponsor from '@/components/Sponsor/Sponsor.vue'
import CommercialZone from '@/components/CommercialZone/CommercialZone.vue'
import Download from '@/components/Download/Download.vue'
import Schedule from '@/components/Schedule/Schedule.vue' */

export default {
  name: 'Home',
  components: {
    Header
    /* , Aside
    , Instructors
    , Sponsor
    , CommercialZone
    , Download
    , Schedule */
  },
  props: ['oc','sl'], // come from route
  data() {
    return {
      video_start : false,
      title_msg: null,
      body_msg: null,
      email: null,
      streaming_url:[],
      streaming_room: null
    }
  },
  created() {
  },
  beforeCreate () {
    this.$store.commit(
      'set_room', 
      { value: "virtual",text: "Streaming", room:"streaming-general"}
    )
  },
  methods: {
    joinUrl() {
      // Create link in memory
      var a = window.document.createElement("a");
      a.target = '_blank';
      a.href = this.assistant.join_url;
  
      // Dispatch fake click
      var e = window.document.createEvent("MouseEvents");
      e.initMouseEvent("click", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      a.dispatchEvent(e);
    },
    showVideo( data ) {
      /* this.streaming_url = [
        {
          value: this.event.url_to, 
          text: "Idioma Seleccionado Español"
        },
        {
          value: this.event.redirect_to, 
          text: "Language Selected English"
        },
      ] */
      if(data) {
        this.streaming_url = data.urls
        this.streaming_room = { id: data.id, name: data.name }
        this.video_start = true
      }
    },
    showMsgBox(msg) {
      if(msg && msg.title){
        this.$bvModal.msgBoxOk(msg.text, {
          title: msg.title,
          titleClass: 'h2',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
        })
        .then(value => { //redirect on automatic to mew tab
        })
        .catch(err => {
          // An error occurred
        })
      }
    },
    showHtmlMsgBox(msg) {
      this.title_msg= msg.title
      this.body_msg = msg.text
      this.$bvModal.show('modal_msg')
    },
  },
  beforeMount () {
    
  },
  mounted () {
    
  },
  computed: {
    
    isLoggedIn : function() {
      return this.$store.getters.isLoggedIn
    },
    assistant : function() {
      return this.$store.getters.assistant
    },
    broadcasting : function() {return this.$store.getters.eventBroadcasting},
    urlTo : function() {
      return this.$store.getters.urlTo
    },
    eventKeyId : function() { return this.$store.getters.eventKeyId },
    event : function() { return this.$store.getters.event },
    streamIsIframe : function() { return this.$store.getters.streamIsIframe },
    
  },
  watch: {
    event(newValue, oldValue) {
      if(!newValue.demo_mode) {
        this.video_start = false
      }
    },
    isLoggedIn(newValue, oldValue) {
      let module_second = this.$store.getters.getModule('SecondStream')
      if(newValue && this.event.demo_mode == 1 && (!module_second || (module_second && module_second.active != 1))) {
        this.showVideo(
          {
            id: 'streaming-general', 
            name: 'En vivo',
            urls: [
              {
                value: this.event.url_to, 
                text: "Idioma Seleccionado Español"
              },
              {
                value: this.event.redirect_to, 
                text: "Language Selected English"
              },
            ]
          }
        )
      }
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/app';

</style>
